import { ExternalLink } from "@octopusdeploy/design-system-components";
import React from "react";
import { ExternalLinkSlugs } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDConstants";
export const ConfigurationMessages = {
    Name: {
        Validation: {
            AlreadyExists: "An Argo CD instance with this name already exists. Please choose a different name.",
            NotProvided: "Please enter a name for this Argo CD instance.",
            UnableToValidate: "Unable to validate if the name is unique. Please try again.",
        },
        HelperText: "You can use the same name as your Kubernetes cluster.",
    },
    Environments: {
        Validation: {
            NotProvided: "Please select an environment for this Argo CD instance.",
        },
        HelperText: "Select at least one environment for this instance to be scoped to.",
    },
    ArgoCDUri: {
        Validation: {
            NotProvided: "Please enter the name & namespace of the Argo CD Server.",
            Invalid: "Please enter a valid Argo CD Server URL.",
        },
        HelperText: "Provide the in-cluster URL for the Argo CD API server.",
    },
    ArgoCDAuthToken: {
        Validation: {
            NotProvided: "Please enter an authentication token.",
            Expired: "The JWT bearer token has expired.",
            Invalid: "Please enter a valid Argo CD JWT bearer token.",
        },
        HelperText: (<span>
                Generate a token with the <ExternalLink href={ExternalLinkSlugs.CliGenerateTokenDocs} label="Argo CD CLI"/>.
            </span>),
    },
    ServerUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server URL.",
            Invalid: "Please enter a valid Octopus Deploy Server URL.",
        },
        HelperText: "Provide the full URL to your Octopus Deploy instance.",
    },
    ServerGrpcUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server gRPC URL.",
            Invalid: "Please enter a valid Octopus Deploy Server gRPC URL.",
        },
        HelperText: "Provide the full gRPC URL to your Octopus Deploy instance.",
    },
} as const;
